import { createAction } from 'redux-act';

const PREFIX = 'GLOBAL_SETTINGS';

export const loadSegmentSuccess = createAction<void>(`${PREFIX}/LOAD_SEGMENT_SUCCESS`);
export const initSegmentIdentity = createAction<void>(`${PREFIX}/INIT_SEGMENT_IDENTITY`);
